import {RDX_NAV_NAVIGATE, RDX_NAV_NAVIGATE_DONE} from './navAction';

const initial = {
	currentFunction: 'NA',
	previousFunction: 'NA',
	params: {},
	transientPeriod: false
};



const nav = (state = initial, action) => {
	let newState = {...state};
	switch (action.type) {
		case RDX_NAV_NAVIGATE :
			if (action.target !== state.currentFunction) {
				return {
					'currentFunction': action.target,
					'previousFunction': state.currentFunction,
					'params': action.params ? action.params : {},
					'transientPeriod' : true
				};
			} else {
				return state;
			}
		case RDX_NAV_NAVIGATE_DONE :
			if (newState.transientPeriod) {
				newState.transientPeriod = false;
				return newState;
			} else {
				return state;
			}
		default:
			return state;
	}
};

export default nav;